import('./toaster.js').then(({ TcmsToaster, TcmsToasterType }) => {
    const toaster = new TcmsToaster();

    Array.from(document.querySelectorAll('.tcms-delete-prompt')).forEach((dp) => {
        dp.addEventListener('click', (e) => {
            const answer = confirm('Do you want to delete?');

            if (answer) {
                toaster.add({
                    title: 'Error',
                    text: 'Item deleted',
                    type: TcmsToasterType.INFO,
                    delay: 0
                });
            } else {
                e.preventDefault();
            }
        });
    });
});
